import { memo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { setRisPopup } from "../model/actions";

import Button from "./controls/Button";
import UIDialog from "./controls/Dialog";
import NoRealtimeIcon from "./NoRealtimeIcon";

import "./RisPopup.scss";

function RisPopup() {
  const risPopup = useSelector((state) => state.risPopup);
  const dispatch = useDispatch();

  const close = useCallback(() => {
    dispatch(setRisPopup(false));
  }, [dispatch]);

  return (
    <UIDialog
      className="trl-popup"
      classNameChildren="trl-popup-content"
      classNameCloseBt="trl-popup-close-btn"
      isModal
      isOpen={risPopup}
      onClickOutside={close}
      onClose={close}
    >
      <div className="trl-popup-title">
        <NoRealtimeIcon data-testid="norealtime-icon" />
        <span>Es liegt keine Echtzeitposition vor.</span>
      </div>
      <span>Es sind Abweichungen zu den angezeigten Zeiten möglich.</span>
      <Button className="trl-popup-ok-btn" onClick={close}>
        Ok
      </Button>
    </UIDialog>
  );
}

export default memo(RisPopup);
